/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Exception_ReturnedInputs */

const tr_geliver_tracking_exception_returned = /** @type {(inputs: Geliver_Tracking_Exception_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İade gönderisi`)
};

const en_geliver_tracking_exception_returned = /** @type {(inputs: Geliver_Tracking_Exception_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return shipment`)
};

const de_geliver_tracking_exception_returned = /** @type {(inputs: Geliver_Tracking_Exception_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rücksendung`)
};

const ru_geliver_tracking_exception_returned = /** @type {(inputs: Geliver_Tracking_Exception_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возврат`)
};

/**
* | output |
* | --- |
* | "Return shipment" |
*
* @param {Geliver_Tracking_Exception_ReturnedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_exception_returned = /** @type {((inputs?: Geliver_Tracking_Exception_ReturnedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Exception_ReturnedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_exception_returned(inputs)
	if (locale === "de") return de_geliver_tracking_exception_returned(inputs)
	if (locale === "ru") return ru_geliver_tracking_exception_returned(inputs)
	return tr_geliver_tracking_exception_returned(inputs)
});